/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DisplayedProfile } from './';
import {
    DisplayedProfileFromJSON,
    DisplayedProfileFromJSONTyped,
    DisplayedProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface UnselectFreelancersRequest
 */
export interface UnselectFreelancersRequest {
    /**
     * 
     * @type {string}
     * @memberof UnselectFreelancersRequest
     */
    advancedSearchQueryId: string;
    /**
     * 
     * @type {Array<DisplayedProfile>}
     * @memberof UnselectFreelancersRequest
     */
    profiles: Array<DisplayedProfile>;
}

/**
 * Check if a given object implements the UnselectFreelancersRequest interface.
 */
export function instanceOfUnselectFreelancersRequest(value: object): value is UnselectFreelancersRequest {
    if (!('advancedSearchQueryId' in value) || value['advancedSearchQueryId'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function UnselectFreelancersRequestFromJSON(json: any): UnselectFreelancersRequest {
    return UnselectFreelancersRequestFromJSONTyped(json, false);
}

export function UnselectFreelancersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnselectFreelancersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'],
        'profiles': ((json['profiles'] as Array<any>).map(DisplayedProfileFromJSON)),
    };
}

export function UnselectFreelancersRequestToJSON(value?: UnselectFreelancersRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => DisplayedProfileToJSON(v))),
    };
}

